export default "__VITE_ASSET__C9xvyJdL__"